<template>
  <div class="grid gap-4 md:grid-cols-2 grid-cols-1 mt-8">
    <div class="flex flex-col justify-center items-start px-16">
      <ul>
        <Transition name="fade" mode="out-in">
          <li class="pt-10 text-center md:text-left" :key="currentItem.id">
            <h1 class="text-2xl md:text-4xl font-bold">
              {{ currentItem.title }}
            </h1>
            <h3 class="py-3 text-text-base md:text-base text-textLightGray">
              {{ currentItem.description }}
            </h3>
          </li>
        </Transition>
      </ul>

      <div class="mt-4 w-full flex justify-center">
        <div class="flex gap-2">
          <div
            v-for="(item, index) in itemCarousel"
            :key="index"
            @click="currentIndex = index"
            class="w-3 h-3 rounded-full flex items-center justify-center cursor-pointer"
            :class="
              currentIndex === index ? 'bg-gray-300' : 'bg-gray-300 opacity-60'
            "
          >
            <div
              v-if="currentIndex === index"
              class="w-1.5 h-1.5 bg-primary rounded-full"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden md:flex items-center justify-center py-10">
      <div class="relative">
        <img
          :src="require('@/assets/images/nurse.png')"
          alt="Logo"
          class="w-full h-auto max-h-[600px] sm:max-h-[400px] md:max-h-[500px] lg:max-h-[600px] object-cover"
        />
        <div
          class="absolute top-12 left-4 w-56 bg-white/20 backdrop-blur-md text-black px-4 py-3 rounded-2xl border border-white/40 shadow-[0_0_20px_rgba(0,0,0,0.1)] animate-bounce-fast"
        >
          <div class="flex items-center flex-col gap-2">
            <span class="flex items-center h-full">
              <div class="bg-blue-500 rounded-full p-3">
                <SVGVideoCall class="text-white w-6 h-6" />
              </div>
            </span>
            <h1 class="text-base text-center">
              Real-Time Video & Audio Consult
            </h1>
          </div>
        </div>

        <div
          class="absolute bottom-10 right-12 w-60 bg-white/20 backdrop-blur-md text-black px-4 py-3 rounded-2xl border border-white/40 shadow-[0_0_20px_rgba(0,0,0,0.1)] animate-bounce-fast"
        >
          <div class="flex items-center flex-col gap-2">
            <span class="flex items-center h-full">
              <div class="bg-green-500 rounded-full p-3">
                <SVGCalendar class="text-white w-6 h-6" />
              </div>
            </span>
            <h1 class="text-base text-center">Skip the Hassle, Consult Now</h1>
          </div>
        </div>

        <div
          class="absolute top-4 right-12 w-60 bg-white/20 backdrop-blur-md text-gray-700 px-4 py-3 rounded-2xl border border-white/40 shadow-[0_0_20px_rgba(0,0,0,0.1)] animate-bounce-fast"
        >
          <div class="flex items-center flex-col gap-2">
            <span class="flex items-center h-full">
              <div class="bg-yellow-500 rounded-full p-3">
                <SVGDocument class="text-white w-6 h-6" />
              </div>
            </span>
            <h1 class="text-base text-center">E-Prescription, One Tap Away</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import SVGVideoCall from "@/components/svgs/videocall.vue";
import SVGCalendar from "@/components/svgs/calendar.vue";
import SVGDocument from "@/components/svgs/document.vue";

export default {
  components: {
    SVGVideoCall,
    SVGCalendar,
    SVGDocument,
  },
  setup() {
    const itemCarousel = ref([
      {
        id: 1,
        title: "Your Health, One Click Away",
        description:
          "Experience convenient, secure, and professional healthcare from the comfort of your home. Our telemedicine system connects you with licensed doctors in just one click.",
      },
      {
        id: 2,
        title: "Bringing Care Closer, Even Without Connection",
        description:
          "Experience healthcare anywhere, anytime. Our telemedicine system lets you access medical services without internet — all through simple text messaging.",
      },
      {
        id: 3,
        title: "Next in Line, Anytime",
        description:
          "Eliminate the hassle of long waits with our smart queuing system. Reserve your spot virtually—anytime, anywhere. Stay updated and in control, even with limited internet access.",
      },
    ]);

    const currentIndex = ref(0);
    const currentItem = computed(() => itemCarousel.value[currentIndex.value]);

    const next = () => {
      currentIndex.value = (currentIndex.value + 1) % itemCarousel.value.length;
    };

    onMounted(() => {
      setInterval(() => {
        next();
      }, 10000);
    });

    return {
      itemCarousel,
      currentItem,
      currentIndex,
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
